import axios from "axios";
import { ApiResponse } from "common/models/ApiResponse";
import { ApiBase } from "config";
import { IEventRegistrationGridPostModel } from "features/eventRegistration/api/types";
import { showError } from "./showMessages";

const makeRequest = async <T>(
  url: string,
  options: any = {}
): Promise<ApiResponse<T>> => {
  const response = await fetch(url, options);

  if (response.ok) {
    const apiData: T = await response.json();

    return {
      apiData,
      status: response.status,
    };
  } else if (response.status === 404) {
    const apiData: ApiResponse<T> = await response.json();

    const data: ApiResponse<T> = {
      status: response.status,
      title: apiData.title,
    };
    return data;
  }

  const apiResponse: ApiResponse<T> = await response.json();
  return apiResponse;
};

export default class api {
  static getAll(model: IEventRegistrationGridPostModel): any {
    throw new Error("Method not implemented.");
  }
  static async post<T>(url: string, body: any = {}): Promise<ApiResponse<T>> {
    const alteredOptions = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("serviceToken")}`,
      },
      body: JSON.stringify(body),
      method: "POST",
    };

    const apiResponse = await makeRequest<T>(url, alteredOptions);
    return apiResponse;
  }

  static async get<T>(url: string): Promise<ApiResponse<T>> {
    const alteredOptions = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("serviceToken")}`,
      },
      method: "GET",
    };

    const data = await makeRequest<T>(url, alteredOptions);
    return data;
  }

  static async delete<T>(url: string): Promise<ApiResponse<T>> {
    const alteredOptions = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("serviceToken")}`,
      },
      method: "DELETE",
    };

    const data = await makeRequest<T>(url, alteredOptions);
    return data;
  }

  static async put<T>(url: string, body: any = {}): Promise<ApiResponse<T>> {
    const alteredOptions = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("serviceToken")}`,
      },
      body: JSON.stringify(body),
      method: "PUT",
    };

    const apiResponse = await makeRequest<T>(url, alteredOptions);
    return apiResponse;
  }

  static async fetch(url: string, options: any = {}): Promise<Response> {
    const alteredOptions = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("serviceToken")}`,
      },
      ...options,
    };
    return await fetch(url, alteredOptions);
  }

  static async tempFetch<T>(
    url: string,
    options: any = {}
  ): Promise<ApiResponse<T>> {
    const alteredOptions = {
      headers: {
        "Content-Type": "application/json",
      },
      ...options,
    };
    const apiResponse = await makeRequest<T>(url, alteredOptions);
    return apiResponse;
  }

  static async upload<T>(
    url: string,
    formData: FormData
  ): Promise<ApiResponse<T>> {
    const alteredOptions = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("serviceToken")}`,
      },
      body: formData,
      method: "POST",
    };

    const apiResponse = await makeRequest<T>(url, alteredOptions);
    return apiResponse;
  }

  static async downloadExcel<TModel>(
    apiURL: string,
    fileName: string,
    data: TModel,
    setLoading: (data: boolean) => void
  ) {
    try {
      const response = await axios.post(`${ApiBase}/${apiURL}`, data, {
        headers: {
          "Content-Type": "application/json",

          Authorization: `Bearer ${localStorage.getItem("serviceToken")}`,
        },
        responseType: "blob",
      });
      if (response.status === 200) {
        setLoading(false);
        const excelBlob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(excelBlob);

        const tempLink = document.createElement("a");
        tempLink.href = url;
        const now = new Date()
          .toISOString()
          .replace(/[:.]/g, "-")
          .split("T")
          .join("_")
          .slice(0, 19);
        tempLink.setAttribute("download", `${fileName}${now}.xlsx`);

        document.body.appendChild(tempLink);
        tempLink.click();

        tempLink.remove();
        window.URL.revokeObjectURL(url);
      }

      return response;
    } catch (error: any) {
      setLoading(false);
      showError(error.response.statusText);
    }
  }
}
